import React from 'react'
import logConversionEventQuickShopUtil from 'containers/QuickShopProductSidebar/utils/log-conversion-event'

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param props.price
 * @param props.product
 * @param props.discountPrice
 * @param props.variantIdFromUrl
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarLogConversionEvent ({
  productVariant,
  price,
  product,
  discountPrice,
  variantIdFromUrl
}) {
  const itemViewedByVariantIdMapRef = React.useRef({})
  const logViewItemEvent = () => {
    logConversionEventQuickShopUtil({
      productVariant,
      price,
      product,
      discountPrice
    })
  }

  React.useEffect(() => {
    if (
      productVariant &&
      product &&
      variantIdFromUrl &&
      !itemViewedByVariantIdMapRef.current[variantIdFromUrl]
    ) {
      logViewItemEvent()
      itemViewedByVariantIdMapRef.current[variantIdFromUrl] = true
    }
  }, [
    productVariant,
    product
  ])

  return <></>
}
